
import { TestResult } from "@/hooks/useTestResults";
import { calculateAverageScore } from "../test-scoring/calculations";

export const checkImprovement = (testResults: TestResult[]): boolean => {
  const sortedResults = [...testResults].sort(
    (a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );
  
  if (sortedResults.length < 3) return false;
  
  for (let i = 0; i < sortedResults.length - 2; i++) {
    if (
      sortedResults[i].score < sortedResults[i + 1].score &&
      sortedResults[i + 1].score < sortedResults[i + 2].score
    ) {
      return true;
    }
  }
  return false;
};

export const checkConsistency = (testResults: TestResult[]): boolean => {
  const sortedResults = [...testResults].sort(
    (a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );

  if (sortedResults.length < 3) return false;

  for (let i = 0; i <= sortedResults.length - 3; i++) {
    if (
      sortedResults[i].score >= 80 &&
      sortedResults[i + 1].score >= 80 &&
      sortedResults[i + 2].score >= 80
    ) {
      return true;
    }
  }
  return false;
};

export const checkMastery = (testResults: TestResult[]): boolean => {
  const categories = new Set(testResults.map(result => result.tests.category));
  
  return Array.from(categories).some(category => {
    const categoryResults = testResults.filter(result => result.tests.category === category);
    return categoryResults.length >= 3 && categoryResults.every(result => result.score >= 90);
  });
};

export const checkCategoryMastery = (testResults: TestResult[], category: string): boolean => {
  const categoryResults = testResults.filter(result => result.tests.category === category);
  
  if (categoryResults.length < 3) return false;
  
  const averageScore = calculateAverageScore(categoryResults);
  return averageScore >= 90;
};
